import React, { useEffect, useState } from "react"
import "./Error.sass"
import imageLogin from "../../static/login-image.png"
import imageLogo from "../../static/logo-adigital-white.png"

const Error = () => {
  useEffect(() => {
    localStorage.removeItem("accessToken")
  })

  return (
    <div id="login">
      <div className="logo">
        <img src={imageLogo} />
      </div>

      <div className="login-content">
        <div className="form-login">
          <div className="form-content">
            <h2>¡Vaya!</h2>
            <p>
              Se ha producido un error. Es posible que tu sesión haya caducado o que no tengas acceso al recurso al que intentabas acceder. Vuelve a intentarlo pasados unos minutos. 
              Si sigues teniendo problemas para acceder, contacta con nosotros en{" "}
              <a href="mailto: info@adigital.org">info@adigital.org</a>.
            </p>
            <p>
              ¿No eres Asociado de Adigital? Únete a la mayor red de empresas de la economía digital.{" "}
              <a href="https://www.adigital.org/contacto/">Solicita información</a>.
            </p>
          </div>
        </div>
        <div className="login-image">
          <img src={imageLogin} />
        </div>
      </div>
    </div>
  )
}

export default Error
